import React, { useState } from "react";
import "./SharedTable.scss";
import { Card, Row, Col, Pagination, Modal, Tooltip, Badge, Button , Spin, Input } from "antd";
import { ExclamationCircleOutlined, LoadingOutlined ,SyncOutlined } from "@ant-design/icons";
import ViewData from "../../assets/icons/view-data.svg";
import EditIcon from "../../assets/icons/zs-icon-edit-fill.svg";
import EditIconDiabled from "../../assets/icons/zs-icon-edit-fill-diabled.svg";
import CopyIcon from "../../assets/icons/copy.svg";
import ShareIcon from "../../assets/icons/share.svg";
import DeleteIcon from "../../assets/icons/delete.svg";
import DeleteDiabledIcon from "../../assets/icons/delete-disabled.svg";
import GeographyIcon from "../../assets/icons/geography-icon.svg";
import DmographicIcon from "../../assets/icons/demographic-icon.svg";
import UseCaseIcon from "../../assets/icons/use-case-icon.svg";
import ShareAnalysis from "../../components/share-analysis/ShareAnalysis";
import { useDispatch, useSelector } from "react-redux";
import {
  setFindingsReportAnalysisData,
  setFindingsReportAnalysisId,
  setIsFindingsReportFullWidth,
  setIsFindingsReportIsOpen,
  setRefreshAnalysisList,
  setNotificationData,
  setHasAccessToReport,
  setRefreshModal1Open, 
  setRefreshModal2Open, 
  setDisableReportIndex,
  setFilterExportLibraryCurrentPageData,
  setRefreshModal2Action,
  setExploreFilterApplyData,
  setFindingReportData,
  setRefreshModal1Action,
  setTargetPopulationFilterData
} from "../../reducer/PEBCommonSlice";
import {
  copyAnalysis,
  deleteCreatedAnalysis,
} from "../../services/ExperienceBankAPI";
import { NotificationTypes } from "../../shared/Notification/Notification";
import {
  createSearchParams,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import { useRefreshActions } from "../refreshReportFunctions/useRefreshFunctions";
import FindingReportSettingsModal from "../../components/finding-report-setting-modal/FindingReportSettingsModal";
import RespondentFilter from "../../components/respondent-filter-drawer/RespondentFilter";


const SharedTable = (props) => {
  const {
    openFirstModal,
    handleFirstModalClick,
    handleSecondModalClick,
    isMaxAllowedCardsLimitReached
  } = useRefreshActions();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.PEBCommon?.userDetail); // get User details
  const filterExportLibraryCurrentPageData = useSelector((state)=>state.PEBCommon?.refreshReport.filterExportLibraryCurrentPageData);
  const checkCardLimitRunning = useSelector((state)=>state.PEBCommon?.refreshReport.checkCardLimitRunning);


  const maxItems = 1;
  const { confirm } = Modal;
  // const [currentPage, setCurrentPage] = useState(props.currentPageNo);
  const pageSize = 4;
  const startIndex = (props.currentPageNo - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentPageData = props.filteredData;
  const dispatch = useDispatch();
  const [rowDetail, setRowDetail] = useState();
  const [shareFlag, setShareFlag] = useState(false);

  const [loading,setLoading] = useState(false);

  useEffect(()=>{
    dispatch(setRefreshModal2Action(null))
  },[])

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 30,
      }}
      spin
    />
  );

 
  // const[disableReportIndex,dispatch(setDisableReportIndex] = use)State(-1);
  const[isCreateExportModalOpen,setIsCreateExportModalOpen] = useState(false);


  const refreshModal1Open = useSelector((state) => state.PEBCommon?.refreshReport?.refreshModal1Open);
const refreshModal2Open = useSelector((state) => state.PEBCommon?.refreshReport?.refreshModal2Open);
const refreshModal1Action = useSelector((state) => state.PEBCommon?.refreshReport?.refreshModal1Action);
const refreshModal2Action = useSelector((state) => state.PEBCommon?.refreshReport?.refreshModal2Action);
  const supportingData = useSelector(
    (state) => state.PEBCommon?.supportingData
  );

const oldAnalysisId = useSelector((state) => state.PEBCommon?.refreshReport?.oldAnalysisId);
// const newAnalysisId = useSelector((state) => state.PEBCommon?.refreshReport?.newAnalysisId);
  const filterData = useSelector((state) => state.PEBCommon?.filterData);
    const recordData = useSelector((state) => state.PEBCommon?.recordData);
    const disableReportIndex = useSelector((state)=>state.PEBCommon?.refreshReport.disableReportIndex);
  
    const DisableReportIds = useSelector((state)=>state.PEBCommon?.refreshReport.DisableReportIds);

  
    useEffect(()=>{
    // console.log("hulk currentPageData",currentPageData);
    
    dispatch(setFilterExportLibraryCurrentPageData(currentPageData));
  },[currentPageData])




const [newRefreshReportName,setNewRefreshReportName] = useState("");
const handleNameChange=(e)=>{
  setNewRefreshReportName(e.target.value);
}



  const handleChangePage = (page) => {
    props.setPageData(page);
  };

  const shareModalOpen = (state, row) => {
    setShareFlag(state);
    setRowDetail(row);
  };
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  let id = searchParams.get("id");
  useEffect(() => {
    if (id) {
      handleClick(id);
    }
  }, [id]);

  const handleClick = (
    id,
    description = "",
    name = "",
    last_updated = "",
    edit_access_flag = false
  ) => {
    dispatch(setFindingsReportAnalysisId(id));
    dispatch(setIsFindingsReportIsOpen(true));
    // if (true) {
    localStorage.setItem("analysisId", id);
    // dispatch(setFindingsReportAnalysisId(id));
    // } else {
    // localStorage.removeItem("analysisId");
    // }
    dispatch(setIsFindingsReportFullWidth(true));
    dispatch(setHasAccessToReport(edit_access_flag));
    dispatch(
      setFindingsReportAnalysisData({
        id,
        name,
        description,
        last_updated,
        quesMaxUpdatedTs: props.quesMaxUpdatedTs,
        edit_access_flag,
      })
    );
  };
  const handleViewDataClick = (
    id,
    description = "",
    name = "",
    last_updated = "",
    edit_access_flag = false
  ) => {
    dispatch(setFindingsReportAnalysisId(id));

    dispatch(setIsFindingsReportIsOpen(true));
    localStorage.setItem("analysisId", id);

    dispatch(setHasAccessToReport(edit_access_flag));

    dispatch(
      setFindingsReportAnalysisData({
        id,
        name,
        description,
        last_updated,
        quesMaxUpdatedTs: props.quesMaxUpdatedTs,
        edit_access_flag: edit_access_flag,
      })
    );
    navigate("/explore", { state: { tabValue: "2", edit_access_flag } });
  };

  // ------- API Calls --------

  //Delete Analysis
  const deleteAnalysis = async (id, analysis_name) => {
    const payload = {
      user_id: userInfo.user_id,
      analysis_id: id,
      screen_name: "analysis",
      analysis_name,
    };
    const response = await deleteCreatedAnalysis(payload);
    dispatch(setRefreshAnalysisList(response));
    dispatch(
      setNotificationData({
        type: NotificationTypes.SUCCESS,
        message: response?.message,
      })
    );
  };

  //Copy Analysis
  const createCopyAnalyis = async (id, name) => {
    const payload = {
      user_id: userInfo.user_id,
      analysis_id: id,
      analysis_name: name,
      screen_name: "analysis",
    };

    let response = await copyAnalysis(payload);
    dispatch(setRefreshAnalysisList(response?.result));
    dispatch(
      setNotificationData({
        type: NotificationTypes.SUCCESS,
        message: response?.message,
      })
    );
  };

  //Confirmation Popup for Deleting an Analysis
  const showConfirm = (id, name) => {
    confirm({
      title: "Are you sure you want to delete this analysis?",
      icon: <ExclamationCircleOutlined />,
      content:
        "Deleting an analysis is final and all associated analysis findings will be removed.",
      okText: "Delete",
      className: "modal-delete",
      onOk() {
        deleteAnalysis(id, name);
      },
      onCancel() {},
    });
  };


  const getModalFooter = () => {
    // if (refreshModal2Action === "refreshCreateNewExport") {
    //   return [
    //     <Button
    //       key="submitUpdate"
    //       type="primary"
    //       onClick={() => handleSecondModalClick("refreshSubmitNewName",newRefreshReportName,currentPageData[disableReportIndex])}
    //     >
    //       Submit
    //     </Button>
    //   ];
    // }
  
    return [
      <Button
        className="custom-disabled-button"
        disabled={
          userInfo.user_email !== currentPageData[disableReportIndex]?.created_by_email_id ||
          currentPageData[disableReportIndex]?.analysis_lock_flag || checkCardLimitRunning
        }
        // onClick={async () => {
        //   const isLimitReached = await isMaxAllowedCardsLimitReached();
        //   if (!isLimitReached) {
        //     handleSecondModalClick("refreshExistingExport","",currentPageData[disableReportIndex])
        //   }
        // }}
        key="refreshExistingExport"
        onClick={() => handleSecondModalClick("refreshExistingExport","",currentPageData[disableReportIndex])}
      >
        Refresh Existing Export
      </Button>,
      <Button
        key="refreshCreateNewExport"
        type="primary"
        disabled={checkCardLimitRunning}
        // onClick={async () => {
        //   const isLimitReached = await isMaxAllowedCardsLimitReached();
        //   if (!isLimitReached) {
        //     handleSecondModalClick("refreshCreateNewExport","",currentPageData[disableReportIndex]);
        //     setIsCreateExportModalOpen(true);
        //   }
        // }}
        onClick={() => {
          handleSecondModalClick("refreshCreateNewExport","",currentPageData[disableReportIndex]);
          setIsCreateExportModalOpen(true);
        }}
      >
        Create New Export
      </Button>
    ];
  };
  




  return (
    <div style={{ marginTop: 20 }}>
       {refreshModal1Action=="refreshUpdateCriteria" ? (
            <div>
              <RespondentFilter
                visible={true}
                onClose={() =>(
                  dispatch(setRefreshModal1Open(false))
                  ,
                  dispatch(setRefreshModal1Action(''))
                  // ,dispatch(setDisableReportIndex(-1))
                  //  ,dispatch(setExploreFilterApplyData([]))
                )}
                refreshScreen={true}
              />
            </div>
          ) : (
            ""
          )}
          {/* analysis_refresh_date */}

      {isCreateExportModalOpen 
      // refreshModal1Action=="refreshUpdateCriteria" 
      && (
        <FindingReportSettingsModal
          isOpen={
            // refreshModal1Action=="refreshUpdateCriteria" 
            isCreateExportModalOpen
          }
          setIsOpen={setIsCreateExportModalOpen}
          supporting_data={supportingData}
          filterData={filterData}
          recordData={recordData}
          type={"category_responses"}
          addFlag={false}
          createAddFlag={true}
          analysisID={oldAnalysisId}
          // analysisID=""
          isRefreshScreen={true}
        />
      )}

       <Spin 
            // tip={loadingTip} 
            tip={<div >Loading...</div>} 
      
            indicator={antIcon} spinning={loading}
            style={{
              position: 'fixed',   // Keeps it fixed on the screen even when scrolling
              top: '50%',          // Vertically center it
              left: '50%',
              right:'50%',
              transform: 'translate(-50%, -50%)', // Perfect centering
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              // zIndex: 9,                    // Ensure it appears above other content
              pointerEvents: 'none',
              // background: 'transparent',     // Ensure no background color is added to the spinner
      
          }}
            >
        {/* {(<Modal
                closable={true}
                maskClosable={false}
                open={true}
                // onCancel={handleCancel}
                footer={[
                  <>
                  <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                      // exceedingCardsInReportRef.current = 0;
                      // dispatch(setExceedingCardsInReport(0))
                    }}
                    style={{ backgroundColor: "#27A6A4" }}>
                    Refresh Data
                  </Button>
                  <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                      // exceedingCardsInReportRef.current = 0;
                      // dispatch(setExceedingCardsInReport(0))
                    }}
                    style={{ backgroundColor: "#27A6A4" }}>
                    Update Criteria
                  </Button>
                  <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                      // exceedingCardsInReportRef.current = 0;
                      // dispatch(setExceedingCardsInReport(0))
                    }}
                    style={{ backgroundColor: "#27A6A4" }}>
                    Cancel
                  </Button>
                  </>
                  
                ]}>
                  <p><strong>How would you like to refresh the report?
        </strong></p>
        <p>Would you prefer to refresh the report with the latest data, or refresh the report using new criteria/target population?</p>
               
              </Modal>)} */}

      <Modal
        title="Refresh Report"
        maskClosable={false}
        // loading={true}
        // zIndex={0}
        // open={true}
        closable={checkCardLimitRunning?false:true}
        open={refreshModal1Open}
        onCancel={() => (dispatch(setRefreshModal1Open(false)),dispatch(setDisableReportIndex(-1))
         ,dispatch(
                    setFindingReportData({
                      insight_list: [],
                      supporting_data: [],
                    })
                  )
        )}
        footer={[
       
          <Button key="refreshUpdateCriteria" 
          type="primary" 
          disabled={checkCardLimitRunning}

          onClick={() => (handleFirstModalClick('refreshUpdateCriteria',filterExportLibraryCurrentPageData[disableReportIndex])
          // ,setIsCreateExportModalOpen(true)
          )}
          >
            Yes,Update Criteria
          </Button>,
            <Button
            key="refreshData"
            disabled={checkCardLimitRunning}
            onClick={async () => {
              const isLimitReached = await isMaxAllowedCardsLimitReached();
              if (!isLimitReached) {
                handleFirstModalClick(
                  'refreshData',
                  filterExportLibraryCurrentPageData[disableReportIndex]
                );
              }
            }}
          >
            No, Just Refresh Data
          </Button>
          
        ]}
      >
        {/* <p><strong>
        </strong></p> */}
        <p>This report will be refreshed with the latest data.</p>
        <p>Would you also like to update the target population or criteria before refreshing?</p>
               
      </Modal>

      {/* Second Modal */}
      <Modal
        title="Refresh Report"
        maskClosable={false}
        closable={checkCardLimitRunning?false:true}
        open={refreshModal2Open}
        onCancel={()=> (dispatch(setRefreshModal2Open(false)) , dispatch(setDisableReportIndex(-1)) ,
        dispatch(setTargetPopulationFilterData([]))
        // not tested yet above condition
        )}
        // footer={[
        //   <Button key="close" onClick={handleSecondModalClick}>
        //     Close
        //   </Button>,
        // ]}


       
        footer={getModalFooter()}





      >
        {/* {getSecondModalContent()} */}
        <p><strong>Do you want to refresh the existing report or create a new one?  </strong></p>
        <p>
          <p style={{fontSize:'12px'}}>
        <strong>Please note: </strong>  
        {/* Some cards won't be refreshed. */}
        Cards added via "Add Top Responses" or containing Open Text Responses will be removed after refresh.</p>
        </p>
      </Modal>





      {currentPageData.map((item, index) => {
       
        return(
        <Card
          key={index}
          hoverable={true}
          style={{
            width: "100%",
            marginBottom: 16,
            height: 145,
            
            // DisableReportIds
            // disableReportIndexes.includes(rowIndex)
            // analysis_id

            // pointerEvents:index==disableReportIndex ? 'none':'auto',
            // opacity: index==disableReportIndex ? 0.5 : 1
            
            
            
            opacity: DisableReportIds.includes(item.analysis_id) ? 0.5 : 1,
            pointerEvents:DisableReportIds.includes(item.analysis_id) ? 'none':'auto',

          }}
          // style={{ width: 300, }}
      // onClick={(e) => e.preventDefault()} 
        >
          <Row className="card-row-1">
            <Col span={12}>
              <div style={{ textAlign: "left" }}>
                <span>
                  <a
                    style={{ fontSize: 16, fontWeight: 600 }}
                    onClick={() =>
                      (handleClick(
                        item.analysis_id,
                        item.analysis_description,
                        item.analysis_name,
                        item.analysis_refresh_date,
                        userInfo.user_email === item.created_by_email_id,
                      ),
                    dispatch(setDisableReportIndex(index))
                    // ,
                    // dispatch(setDisableReportIds(index))
                    )
                    }
                    // onClick={(e) => e.preventDefault()}
                    
                  >
                    {item.analysis_name}
                  </a>
                </span>{" "}
                <br />
                <span
                  style={{ fontSize: 14, fontWeight: 400, color: "#716E79" }}
                >
                  Created By:{" "}
                  <label
                    style={{ fontSize: 14, fontWeight: 600, color: "#716E79" }}
                  >
                    {item.created_by} | {item.created_date}
                  </label>
                </span>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ textAlign: "right", display:'flex', justifyContent:'end' , alignItems:'start' }}>
              {/* <Button 
                  // disabled={(userInfo.user_email != item.created_by_email_id) ||
                  //       item.analysis_lock_flag} 
                  type="primary" 
                  onClick={()=>openFirstModal(index,item.analysis_id,filterExportLibraryCurrentPageData[index])}
              >
                Refresh Icon
              </Button> */}
              <Tooltip title="Refresh">
              <SyncOutlined style={{fontSize:'23px' , color:'#716E79'  , width:'30px' }}
                  onClick={()=>openFirstModal(index,item.analysis_id,filterExportLibraryCurrentPageData[index])}
              ></SyncOutlined>
              </Tooltip>
                {userInfo.user_email === item.created_by_email_id &&
                !item.analysis_lock_flag ? (
                  <a>
                    <Tooltip title="Edit Export">
                      <img
                        alt={"Edit Export"}
                        src={EditIcon}
                        onClick={() =>
                          handleViewDataClick(
                            item.analysis_id,
                            item.analysis_description,
                            item.analysis_name,
                            item.analysis_refresh_date,
                            userInfo.user_email === item.created_by_email_id
                          )
                        }
                      />
                    </Tooltip>
                  </a>
                ) : (
                  <a>
                    <Tooltip
                      title={
                        (userInfo.user_email === item.created_by_email_id) &&
                        item.analysis_lock_flag ? (
                          <>
                            Explore and other functionalities are not active<br />
                            for exports created before 06/09/2024.
                          </>
                        ) : (
                          <>
                            Must be owner of <br />
                            the export to edit.
                          </>
                        )
                      }
                    >
                      <img
                        alt={"Edit Disabled"}
                        style={{ cursor: "auto" }}
                        src={EditIconDiabled}
                      />
                    </Tooltip>
                  </a>
                )}
                {!item.analysis_lock_flag ? (
                  <a>
                    <Tooltip title="View Data">
                      <img
                        style={{ marginLeft: 8 }}
                        alt={"View Data"}
                        src={ViewData}
                        onClick={() =>
                          handleViewDataClick(
                            item.analysis_id,
                            item.analysis_description,
                            item.analysis_name,
                            item.analysis_refresh_date,
                            userInfo.user_email === item.created_by_email_id
                          )
                        }
                      />
                    </Tooltip>
                  </a>
                ) : (
                  <a>
                    <Tooltip 
                    title={
                      (userInfo.user_email === item.created_by_email_id) &&
                      item.analysis_lock_flag ? (
                        <>
                          Explore and other functionalities are not active<br />
                          for exports created before 06/09/2024.
                        </>
                      ):"View Data"
                    } >
                      <img
                        style={{ marginLeft: 8, opacity: 0.5, cursor: "auto" }}
                        alt={"View Data"}
                        src={ViewData}
                      />
                    </Tooltip>
                  </a>
                )}

                {!item.analysis_lock_flag ? (
                  <a>
                    <Tooltip title="Copy">
                      <img
                        style={{ marginLeft: 8 }}
                        alt={"Copy"}
                        src={CopyIcon}
                        onClick={() =>
                          createCopyAnalyis(
                            item.analysis_id,
                            item.analysis_name
                          )
                        }
                      />
                    </Tooltip>
                  </a>
                ) : (
                  <a>
                    <Tooltip title={
                      (userInfo.user_email === item.created_by_email_id) &&
                      item.analysis_lock_flag ? (
                        <>
                          Explore and other functionalities are not active<br />
                          for exports created before 06/09/2024.
                        </>
                      ):"Copy"
                    }>
                      <img
                        style={{ marginLeft: 8, opacity: 0.5, cursor: "auto" }}
                        alt={"Copy"}
                        src={CopyIcon}
                      />
                    </Tooltip>
                  </a>
                )}

                <a>
                  <Tooltip title="Share">
                    <img
                      style={{ marginLeft: 8 }}
                      alt={"Share"}
                      src={ShareIcon}
                      onClick={() => shareModalOpen(true, item)}
                    />
                  </Tooltip>
                </a>
                {userInfo.user_email === item.created_by_email_id ? (
                  <a>
                    <Tooltip title="Delete">
                      <img
                        style={{ marginLeft: 8 }}
                        alt={"Delete"}
                        src={DeleteIcon}
                        onClick={() =>
                          showConfirm(item.analysis_id, item.analysis_name)
                        }
                      />
                    </Tooltip>
                  </a>
                ) : (
                  <a>
                    <img
                      style={{ marginLeft: 8, cursor: "auto" }}
                      alt={"Delete"}
                      src={DeleteDiabledIcon}
                    />
                  </a>
                )}
              </div>
            </Col>
          </Row>
          <Row style={{ padding: 12 }}>
            <Col span={12}>
              <div id="description-overflow" style={{ textAlign: "left" }}>
                <Tooltip title={item.analysis_description}>
                  <span className="card-item-text-description">
                    {item.analysis_description}
                  </span>
                </Tooltip>
              </div>
            </Col>
            <Col span={12}>
              <Row>
                {/* <Divider type="vertical" /> */}

                {/* style={{ width: "33%", float: "left" }} */}

                <div className="country-field">
                  {/* <div className="horizontal-border"> */}

                  <div className="globe-icon">
                    <img
                      alt={"Geography Icon"}
                      src={GeographyIcon}
                      style={{ verticalAlign: "bottom" }}
                    />
                  </div>
                  <div className="card-item-text">
                    {item.geography.slice(0, maxItems).map((item, index) => (
                      <Tooltip key={index} title={item}>
                        <React.Fragment key={index}>
                          {index > 0 && ", "}{" "}
                          {/* Add comma and space except for the first element */}
                          {item.length > 20
                            ? item.substring(0, 15) + "..."
                            : item}
                        </React.Fragment>
                      </Tooltip>
                    ))}
                    {item.geography.length - maxItems > 0 && (
                      <Tooltip
                        title={item.geography.slice(maxItems).join(", ")}
                      >
                        <Badge
                          title=""
                          count={`+${item.geography.length - maxItems}`}
                          showZero
                          color="#DEDCDE"
                          className="badge-class"
                        />
                      </Tooltip>
                    )}
                  </div>

                  {/* <span className="card-item-text">{item.geography}</span> */}
                  {/* </div> */}
                </div>

                <div className="country-field">
                  <div className="globe-icon">
                    <img
                      alt={"Dmographic Icon"}
                      src={DmographicIcon}
                      style={{ verticalAlign: "text-bottom" }}
                    />
                  </div>
                  <div className="card-item-text">
                    {item.demographics.slice(0, maxItems).map((item, index) => (
                      <Tooltip title={item} key={index}>
                        <React.Fragment key={index}>
                          {index > 0 && ", "}{" "}
                          {/* Add comma and space except for the first element */}
                          {item.length > 20
                            ? item.substring(0, 15) + "..."
                            : item}
                        </React.Fragment>
                      </Tooltip>
                    ))}
                    {item.demographics.length - maxItems > 0 && (
                      <Tooltip
                        title={item.demographics.slice(maxItems).join(", ")}
                      >
                        <Badge
                          title={""}
                          count={`+${item.demographics.length - maxItems}`}
                          showZero
                          color="#DEDCDE"
                          className="badge-class"
                        />
                      </Tooltip>
                    )}
                  </div>
                  {/* <span className="card-item-text">
                      {item.demographics}
                    </span> */}
                </div>
                <div className="country-field">
                  <div className="globe-icon">
                    <img
                      alt={"Use Case Icon"}
                      src={UseCaseIcon}
                      style={{ verticalAlign: "text-bottom" }}
                    />
                  </div>
                  <div className="card-item-text">
                    {item?.use_case?.slice(0, maxItems).map((item, index) => (
                      <React.Fragment key={index}>
                        {index > 0 && ", "}{" "}
                        {/* Add comma and space except for the first element */}
                        {item}
                      </React.Fragment>
                    ))}
                    {item?.use_case?.length - maxItems > 0 && (
                      <Tooltip
                        title={item.use_case?.slice(maxItems).join(", ")}
                      >
                        <Badge
                          title={""}
                          count={`+${item.use_case?.length - maxItems}`}
                          showZero
                          color="#DEDCDE"
                          className="badge-class"
                        />
                      </Tooltip>
                    )}
                  </div>
                  {/* <span className="card-item-text">{item.use_case}</span> */}
                </div>
              </Row>
            </Col>
          </Row>
        </Card>
      )})}
      <div style={{ float: "right", marginBottom: 16 }}>
        <Pagination
          current={props.currentPageNo}
          pageSize={pageSize}
          total={props.totalCount}
          onChange={handleChangePage}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} Exports`
          }
          showSizeChanger={false}
        />
      </div>
      {shareFlag ? (
        <div>
          <ShareAnalysis
            visible={true}
            rowDetail={rowDetail}
            onClose={() => shareModalOpen(false)}
          />
        </div>
      ) : (
        ""
      )}
    </Spin>
    </div>
  );
};

export default SharedTable;
